import Chiclet from "./Chiclet";
export default Chiclet;
export * from "./Chiclet";
